<template>
  <planejamento-contrato-form
    :somente-leitura="somenteLeitura"
    :novo="novo"
    :edicao="edicao"
    :copia="copia"
    :alterar-finalizado="alterarFinalizado"
    />
</template>
<script>
import PlanejamentoContratoForm from './PlanejamentoContratoForm';

export default {
  props: {
    somenteLeitura: Boolean,
    alterarFinalizado: Boolean,
    copia: Boolean,
    novo: Boolean,
    edicao: Boolean,
  },
  components: {
    PlanejamentoContratoForm,
  },
};
</script>
